export const TEXTS = {
  MODAL_TITLE: 'Ссылка недоступна',
  SUCCESS_BUTTON: 'Понятно',
  WARNING_MESSAGE: 'Для скачивания приложения требуется перейти по ссылке с моб устройства',
};
